export default __webpack_public_path__ + "static/media/Deleted.a87fac65.gif";